module.exports = __webpack_public_path__ + "img/logo.d29aa09a.png";